import React, { createContext, useContext, useState, useEffect } from 'react';
import MainApi from '../../api/MainApi';

const EmbryoSettingsContext = createContext({
  hideEmbryoId: false,
  setHideEmbryoId: () => {},
  addTubeCheck: false,
  setAddTubeCheck: () => {},
  semenPreparationMethodCheck: false,
  setSemenPreparationMethodCheck: () => {},
  androPdfTemplate: 'Template 1',
  setAndroPdfTemplate: () => {},
  frozenEmbryoPdfTemplate: 'Template 1',
  setFrozenEmbryoPdfTemplate: () => {},
  fetchSettings: () => {},
});

export const EmbryoSettingsProvider = ({ children }) => {
  const [hideEmbryoId, setHideEmbryoId] = useState(false);
  const [addTubeCheck, setAddTubeCheck] = useState(false);
  const [semenPreparationMethodCheck, setSemenPreparationMethodCheck] = useState(false);
  const [androPdfTemplate, setAndroPdfTemplate] = useState('Template 1');
  const [frozenEmbryoPdfTemplate, setFrozenEmbryoPdfTemplate] = useState('Template 1');

  const fetchSettings = async () => {
    try {
      let rawId = localStorage.getItem('hospitalId');
      if (!rawId) return;
      const cId = rawId.startsWith('"') ? JSON.parse(rawId) : rawId;
      let rawToken = localStorage.getItem('token');
      const tok = rawToken && rawToken.startsWith('"') ? JSON.parse(rawToken) : rawToken;
      const res = await MainApi.get(`embryo/getEmbryoGradingSettings?clinicId=${cId}`, {
        headers: { Authorization: `Bearer ${tok}` },
      });
      const data = res?.data?.data || res?.data;
      if (data) {
        setHideEmbryoId(data.hideEmbryoId === true);
        setAddTubeCheck(data.addTubeCheck === true);
        setSemenPreparationMethodCheck(data.semenPreparationMethodCheck === true);
        setAndroPdfTemplate(data.androPdfTemplate || 'Template 1');
        setFrozenEmbryoPdfTemplate(data.frozenEmbryoPdfTemplate || 'Template 1');
      }
    } catch (err) {
      console.error('Error fetching embryo settings in provider:', err);
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  return (
    <EmbryoSettingsContext.Provider
      value={{
        hideEmbryoId,
        setHideEmbryoId,
        addTubeCheck,
        setAddTubeCheck,
        semenPreparationMethodCheck,
        setSemenPreparationMethodCheck,
        androPdfTemplate,
        setAndroPdfTemplate,
        frozenEmbryoPdfTemplate,
        setFrozenEmbryoPdfTemplate,
        fetchSettings,
      }}
    >
      {children}
    </EmbryoSettingsContext.Provider>
  );
};

export const useEmbryoSettings = () => useContext(EmbryoSettingsContext);

export default EmbryoSettingsContext;


